import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './config/RouterConfig';
import PageSpinner from './component/pageSpinner';
import useStore from './store';
import { observer } from 'mobx-react';

const App = observer(() => {
	const { AUTH } = useStore();
	const { InitializeApp, app_loading } = AUTH;

	useEffect(() => {
		InitializeApp();
	}, [InitializeApp]);

	return (
		<div className="App">
			<BrowserRouter>
				{app_loading ? <PageSpinner /> : <Router />}
			</BrowserRouter>
		</div>
	);
});

export default App;
